import styled from "styled-components";
import { grayDark05 } from "../../../styles/colors";

const toHoverBackground = (color = '#eee') => {
    let colorValue = color;
    if (color.startsWith('#')) {
        const r = parseInt(color.slice(1, 3), 16);
        const g = parseInt(color.slice(3, 5), 16);
        const b = parseInt(color.slice(5, 7), 16);
        colorValue = `rgba(${r}, ${g}, ${b}, 0.2)`;
        return colorValue;
    }
    return colorValue.replace(/[\d.]+\)$/, '0.2)');
}

export const ColorTile = styled.div<{ color?: string, borderColor?: string, opacity?: number, isReadOnly?: boolean }>`
    width: 26px;
    height: 26px;
    background: ${({ color }) => color || '#eee'};
    border: 1px solid ${({ borderColor }) => borderColor || 'transparent'};
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    cursor: ${({ isReadOnly }) => (isReadOnly ? 'default' : 'pointer')};
    ${({ isReadOnly, color }) => !isReadOnly && `
        &:hover {
            background: ${toHoverBackground(color)};
        }
    `}
`;

export const PopoverContent = styled.div`
    min-width: 220px;
`;

export const SectionLabel = styled.div<{ marginTop?: boolean }>`
    margin-bottom: 8px;
    ${({ marginTop }) => marginTop && 'margin-top: 12px;'}
    font-weight: bold;
`;

export const PaletteRow = styled.div`
    display: flex;
    gap: 8px;
`;

export const PaletteGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
`;

export const ColorNameSpan = styled.span`
    color: #134FBD;
    text-decoration: none;
`;

export const ColorTileWrapper = styled.div`
    padding: 2px;
    border: 1px solid #ccc;
    border-radius: 4px;
`;

export const ColorPickerTrigger = styled.div<{ color?: string }>`
    cursor: pointer;    
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 8px;
    gap: 4px;
    &:hover, &:active, &.is-active {
        border-color: ${grayDark05};
        ${ColorTileWrapper} {
             border-color: ${grayDark05};
        }
        ${ColorTile} {
            background: ${({ color }) => toHoverBackground(color)};
        }
        ${ColorNameSpan} {
            text-decoration: underline;
        }
    }
`;

